export default "__VITE_ASSET__CdFFwgb9__"